import _extends from 'babel-runtime/helpers/extends';

import mlogo from '@/assets/logo_m.png';
import logo from '@/assets/logo.png';
import { mapGetters } from 'vuex';

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mlogo: mlogo,
      logo: logo
    };
  },

  computed: _extends({}, mapGetters(['sidebar']), {
    submenuScrollStyle: function submenuScrollStyle() {
      if (this.sidebar.opened) {
        return {};
      }
      return {
        'overflow-y': 'scroll',
        'max-height': document.body.clientHeight + 'px'
      };
    }
  })
};